import React from "react";
import { Input } from "components/bootstrap";
const ThreatFoxAdapterFieldSet = ({
  config,
  handleFormEvent,
  validationMessage,
  validationState
}) => /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
  Input,
  {
    type: "checkbox",
    id: "include_older_iocs",
    name: "include_older_iocs",
    label: "Include IOCs Older Than 90 Days",
    checked: config.include_older_iocs,
    onChange: handleFormEvent,
    wrapperClassName: "col-md-offset-3 col-md-9"
  }
), /* @__PURE__ */ React.createElement(
  Input,
  {
    type: "number",
    id: "refresh_interval",
    name: "refresh_interval",
    label: "Refresh Interval (seconds)",
    required: true,
    onChange: handleFormEvent,
    help: validationMessage(
      "refresh_interval",
      "How often to fetch new data from the source (minimum 3600 seconds)."
    ),
    bsStyle: validationState("refresh_interval"),
    value: config.refresh_interval,
    labelClassName: "col-sm-3",
    wrapperClassName: "col-sm-9"
  }
), /* @__PURE__ */ React.createElement(
  Input,
  {
    type: "checkbox",
    id: "case_insensitive_lookup",
    name: "case_insensitive_lookup",
    label: "Case Insensitive Lookups",
    checked: config.case_insensitive_lookup,
    onChange: handleFormEvent,
    wrapperClassName: "col-md-offset-3 col-md-9"
  }
));
export default ThreatFoxAdapterFieldSet;
